import { useEffect } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';

import { DEFAULT_LANGUAGE, STORAGE_KEYS, isLanguageCode } from '@config';

import { useEffectiveLanguage } from '@hooks';

// Activate something synchronously before the first render, or lingui warns
// about an uninitialised i18n (lingui#1194). The pinned profile language if
// there is one, otherwise Czech — the organization's language is not known
// this early, and Czech is what organizations default to anyway.
const pinned = localStorage.getItem(STORAGE_KEYS.LANGUAGE_PREFERENCE);
const initialLanguage = isLanguageCode(pinned) ? pinned : DEFAULT_LANGUAGE;
i18n.load(initialLanguage, {});
i18n.activate(initialLanguage);

const dynamicActivate = async (language: string) => {
  const { messages } = await import(`../locales/${language}.po`);
  i18n.load(language, messages);
  i18n.activate(language);
};

const WithLingui = ({ children }: React.PropsWithChildren) => {
  // Resolves the profile pin against the active organization, so switching
  // organization re-runs this effect and the whole app re-renders translated.
  const language = useEffectiveLanguage();

  useEffect(() => {
    dynamicActivate(language);
  }, [language]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};

export default WithLingui;
